import { PaginationType } from '@models/next/PaginationType';
import { z } from 'zod';

export const ExportCSVType = z.enum(['selected', 'matched', 'all']);

export type ExportCSVType = z.infer<typeof ExportCSVType>;

export const ExportCSVForm = z.object({
  method: ExportCSVType,
});

export type ExportCSVForm = z.infer<typeof ExportCSVForm>;

export class ExportCSVHelper {
  static mapFormToPaginatedQuery<S extends PaginationType>(
    { method }: ExportCSVForm,
    selected: any[],
    query: S,
    defaultQuery: S,
  ): Partial<S> {
    return {
      ...(method === 'matched' ? query : {}),
      ...(method === 'all' ? defaultQuery : {}),
      selected: method === 'selected' ? selected : undefined,
      page: undefined,
      page_size: undefined,
      format: 'csv',
    } satisfies PaginationType as any;
  }
}
